module.exports = __webpack_public_path__ + "img/lg_ring_r_l_null_0.c6af4cf9.png";